import { enableProdMode, importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import { environment } from './environments/environment';
import {
    HTTP_INTERCEPTORS,
    provideHttpClient,
    withInterceptorsFromDi,
    withXsrfConfiguration
} from '@angular/common/http';
import { AbaqusApiKeyInterceptor } from '@shared/interceptors/abaqus-api-key.interceptor';
import { IqarusApiKeyInterceptor } from '@shared/interceptors/iqarus-api-key.interceptor';
import { bootstrapApplication, BrowserModule } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { routes } from "./app/app.routes";
import { provideRouter } from "@angular/router";
import { SpeadApiKeyInterceptor } from '@shared/interceptors/spead-api-key.interceptor';

if (environment.production) {
    enableProdMode();
}

bootstrapApplication(AppComponent, {
    providers: [
        provideZoneChangeDetection(),provideRouter(routes),
        importProvidersFrom(BrowserModule),
        {provide: HTTP_INTERCEPTORS, useClass: AbaqusApiKeyInterceptor, multi: true},
        {provide: HTTP_INTERCEPTORS, useClass: IqarusApiKeyInterceptor, multi: true},
        {provide: HTTP_INTERCEPTORS, useClass: SpeadApiKeyInterceptor, multi: true},
        provideHttpClient(withInterceptorsFromDi(), withXsrfConfiguration({
            cookieName: 'csrftoken',
            headerName: 'X-CSRFToken',
        }))
    ]
})
    .catch(err => console.error(err));
